export const SLIDE_TITLE_CHANGED = 'SLIDE_TITLE_CHANGED';
export const RESET_SLIDE_TITLE_INFO = 'RESET_SLIDE_TITLE_INFO';